
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eymUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afd35e271dc067b$export$2e2bcd8739ae039);
function $0afd35e271dc067b$export$2e2bcd8739ae039(degree) {
    return degree * (Math.PI / 180);
}

});

parcelRegister("g4gW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0d65a8310461d1d$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $i30uN = parcelRequire("i30uN");

var $3f3J1 = parcelRequire("3f3J1");
class $b0d65a8310461d1d$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    AngleValue;
    arc;
    arcStroke;
    tag;
    startRadian;
    endRadian;
    degree;
    fillColor;
    smallDistance = 100;
    smallDistanceOffset = 0;
    addSmallDis = true;
    constructor(tag, angleColor, smallDistanceOffset = 0, addCon = false, addSmallDis = true){
        super();
        this.tag = tag;
        this.fillColor = angleColor.color;
        this.smallDistanceOffset = smallDistanceOffset;
        this.addSmallDis = addSmallDis;
        this.AngleValue = new (0, $i30uN.default)({
            x: -100,
            y: -100
        }, angleColor.textColor);
        this.addArc();
        !addCon && this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Bottom.addChild(this);
    addArc() {
        this.arc = new $iuB9z.Graphics();
        this.addChild(this.arc);
        this.arcStroke = new $iuB9z.Graphics();
        this.addChild(this.arcStroke);
    }
    setVisible(status) {
        this.visible = status;
        this.AngleValue.visible = status;
    }
    draw(cCoord, startRadian, endRadian, degree, cClockwise) {
        const sD = this.smallDistance;
        const radian = sD <= 76 + this.smallDistanceOffset && this.addSmallDis ? Math.max((sD - this.smallDistanceOffset) / 2, 15) : 38;
        this.degree = degree;
        this.startRadian = startRadian;
        this.endRadian = endRadian;
        if (degree == 90) {
            this.arcStroke.clear();
            (0, $3f3J1.drawSquare)(this.arc, radian, startRadian, endRadian, this.fillColor, cClockwise);
        } else {
            (0, $3f3J1.drawArc)(this.arcStroke, radian, startRadian, endRadian, 3, 0x000000, cClockwise, true);
            (0, $3f3J1.drawArc)(this.arc, radian / 2, startRadian, endRadian, radian, this.fillColor, cClockwise, false);
        }
        const initialAngle = cClockwise ? endRadian : startRadian;
        this.AngleValue.setAngleValue(cCoord, initialAngle, degree, radian);
    }
}

});
parcelRegister("i30uN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6935df93860f2c37$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $eymUv = parcelRequire("eymUv");
class $6935df93860f2c37$export$2e2bcd8739ae039 extends $iuB9z.Text {
    Layers = (0, $9ec1t.default).getInstance();
    constructor(coord, color){
        super();
        this.text = "60\xb0";
        this.style.fill = color;
        this.style.fontSize = 34;
        this.style.fontWeight = "800";
        this.anchor.set(.5);
        this.setAngleValue(coord, 0, 0, 38);
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Top.addChild(this);
    setValue = (value)=>this.text = `${value}\xb0`;
    setAngleValue(cCoord, initialAngle, degree, radian) {
        const angle = initialAngle + (0, $eymUv.default)(degree / 2);
        const coord = {
            x: Math.cos(angle) * radian * 1.7 + cCoord.x,
            y: Math.sin(angle) * radian * 1.7 + cCoord.y
        };
        this.setValue(degree);
        this.style.fontSize = radian;
        this.x = coord.x;
        this.y = coord.y;
    }
}

});

parcelRegister("3f3J1", function(module, exports) {

$parcel$export(module.exports, "drawArc", () => $827e00f616855d7e$export$bf8a3f9983094125);
$parcel$export(module.exports, "drawSquare", () => $827e00f616855d7e$export$9340b6a85ea854b9);
function $827e00f616855d7e$export$bf8a3f9983094125(arc, r, sRadian, eRadian, w, color, cClockwise, isStroke) {
    arc.clear();
    if (!isStroke) arc.arc(0, 0, r, sRadian, eRadian, cClockwise).stroke({
        width: w,
        color: color
    });
    else arc.moveTo(Math.cos(sRadian) * r, Math.sin(sRadian) * r).lineTo(0, 0).arc(0, 0, r, sRadian, eRadian, cClockwise).moveTo(0, 0).lineTo(Math.cos(eRadian) * r, Math.sin(eRadian) * r).stroke({
        width: w,
        color: color
    });
    arc.rotation = 0;
}
function $827e00f616855d7e$export$9340b6a85ea854b9(square, dim, startRadian, endRadian, color, cClockwise) {
    square.clear();
    square.rect(0, 0, dim, dim).fill(color).stroke({
        color: 0x000000,
        width: 3
    });
    square.rotation = !cClockwise ? startRadian : endRadian;
}

});


parcelRegister("a92Ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2e4f2e6d187ae4$export$2e2bcd8739ae039);

var $2h5MD = parcelRequire("2h5MD");
function $1f2e4f2e6d187ae4$export$2e2bcd8739ae039(cCoord, coordStart, coordEnd) {
    const startRadian = (0, $2h5MD.default)(cCoord, coordStart);
    const endRadian = (0, $2h5MD.default)(cCoord, coordEnd);
    return {
        startRadian: startRadian,
        endRadian: endRadian
    };
}

});

parcelRegister("cwj7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6eb8af25d6ad3b0$export$2e2bcd8739ae039);

var $74Gga = parcelRequire("74Gga");
function $a6eb8af25d6ad3b0$export$2e2bcd8739ae039({ startRadian: startRadian, endRadian: endRadian }, cClockwise, even = true) {
    let _angle = startRadian - endRadian;
    if (!cClockwise) _angle = endRadian - startRadian;
    let degree = Math.floor((0, $74Gga.default)(_angle));
    degree = degree < 0 ? degree + 360 : degree;
    even && (degree = degree % 2 == 1 ? degree + 1 : degree);
    return degree;
}

});
parcelRegister("74Gga", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b402dd6b18638d$export$2e2bcd8739ae039);
function $e6b402dd6b18638d$export$2e2bcd8739ae039(radian) {
    return Math.round(radian * (180 / Math.PI));
}

});


parcelRegister("9tAmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $13e632069963336c$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $erVR3 = parcelRequire("erVR3");

var $d0yDD = parcelRequire("d0yDD");

var $cdlGy = parcelRequire("cdlGy");

var $jYh5T = parcelRequire("jYh5T");
class $13e632069963336c$export$2e2bcd8739ae039 {
    Layers = (0, $9ec1t.default).getInstance();
    isShownSegment = false;
    line = new (0, $d0yDD.default)({
        color: 0xFF0000,
        width: 6
    });
    segments;
    cCoord;
    constructor(cCoord){
        this.cCoord = cCoord;
        this.addSegments();
    }
    handleSegmentVisible(v) {
        this.isShownSegment = v;
        this.segmentVisibleWithAnimated(v);
    }
    segmentVisibleWithAnimated(v) {
        const sOpacity = v ? 0 : 1;
        const tOpacity = v ? 1 : 0;
        const duration = 100;
        const elms = [
            this.line,
            ...this.segments
        ];
        elms.forEach((elm)=>elm.alpha = sOpacity);
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).drawElements);
        elms.forEach((elm)=>new (0, $jYh5T.default)(elm, sOpacity, tOpacity, duration, ()=>!v ? elm.clear() : ""));
    }
    addSegments() {
        this.segments = Array(2).fill("").map((_)=>new $iuB9z.Graphics());
        this.Layers.BottomUnder.addChild(...this.segments);
    }
    draw(radius, radians, [sCoord, eCoord], clockwise) {
        if (!this.isShownSegment) return;
        this.line.draw(sCoord, eCoord);
        (0, $cdlGy.default)(this.segments, this.cCoord, radius, radians, clockwise);
    }
    clearAll() {
        this.segments.forEach((s)=>s.clear());
        this.line.clear();
    }
}

});
parcelRegister("cdlGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcb2dbd26932bc43$export$2e2bcd8739ae039);

var $hCdov = parcelRequire("hCdov");
function $fcb2dbd26932bc43$export$2e2bcd8739ae039(segments, cCoord, radius, radians, clockwise) {
    const points = (0, $hCdov.default)(cCoord, radians, radius);
    const _rs = [
        [
            radians[0],
            radians[1]
        ],
        [
            radians[1],
            radians[0]
        ]
    ];
    const rs = clockwise ? _rs : _rs.reverse();
    const colors = [
        0xFDEEE4,
        0xDDF9FF
    ];
    segments.forEach((segment, sI)=>{
        segment.clear().moveTo(points[0].x, points[0].y).lineTo(points[1].x, points[1].y).arc(cCoord.x, cCoord.y, radius, rs[sI][0], rs[sI][1]).fill(colors[sI]);
    });
}

});

parcelRegister("jYh5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $016f335fbdc70656$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $016f335fbdc70656$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(elm, sOpacity, tOpacity, duration, onComp){
        super();
        const opacity = {
            alpha: sOpacity
        };
        new (0, $6m47o.default).Tween({
            ...opacity
        }).to({
            alpha: tOpacity
        }, duration).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((o)=>elm.alpha = o.alpha).onComplete(()=>onComp()).start();
    }
}

});


parcelRegister("gix9M", function(module, exports) {

$parcel$export(module.exports, "default", () => $4713a546dfab5e00$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");

var $krubk = parcelRequire("krubk");

var $erVR3 = parcelRequire("erVR3");
class $4713a546dfab5e00$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    Switcher;
    Header;
    coords;
    handleFunc;
    constructor({ header: header, coords: coords, handleFunc: handleFunc }){
        super();
        this.coords = coords;
        this.handleFunc = handleFunc;
        this.addHeader(header);
        this.addCoord();
        this.addSwitcher();
        this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    setVisible = (v)=>this.visible = v;
    addToLayer = ()=>this.Layers.UI.addChild(this);
    addCoord() {
        const dim = this.Game.getDim();
        let coord = this.coords.horizontal;
        if (dim.WIDTH < dim.HEIGHT) coord = {
            x: dim.WIDTH / 2 + this.coords.vertical.x,
            y: dim.HEIGHT / 2 + this.coords.vertical.y
        };
        Object.assign(this, coord);
    }
    addHeader(header) {
        this.Header = new $iuB9z.Text({
            text: header
        });
        this.Header.anchor.set(.5);
        this.Header.x = 0;
        this.Header.y = -32;
        this.addChild(this.Header);
    }
    addSwitcher() {
        const dim = this.Game.getDim();
        this.Switcher = new (0, $krubk.default)(0x55E39F, this.handleFunc, true);
        this.Switcher.scale.set(dim.WIDTH > dim.HEIGHT ? 1.3 : 1.9);
        this.Switcher.x = 0;
        this.Switcher.y = 0;
        this.addChild(this.Switcher);
    }
    getActivationStatus = ()=>this.Switcher.getActive();
    setActivation(v) {
        const isActive = this.Switcher.getActive();
        if (v && isActive) this.Switcher.handleSwitcher(!isActive);
    }
}

});
parcelRegister("krubk", function(module, exports) {

$parcel$export(module.exports, "default", () => $621ca3294779f8aa$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $8xLbP = parcelRequire("8xLbP");

var $erVR3 = parcelRequire("erVR3");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
const $621ca3294779f8aa$var$BUTTON_X = 10;
class $621ca3294779f8aa$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    isActive = false;
    greenBg;
    grayBg;
    button;
    handleSwitch;
    constructor(color, handleSwitch, isAddCon = false){
        super();
        this.handleSwitch = handleSwitch;
        this.greenBg = this.addBg(color);
        this.grayBg = this.addBg(0xDEDEDE);
        this.addButton(0xFFFFFF);
        this.addInteractivity();
        !isAddCon && this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).closeSwitcher, ()=>this.handleSwitcherOff());
    }
    addToLayer = ()=>this.Layers.UI.addChild(this);
    getActive = ()=>this.isActive;
    addBg(color) {
        const bgBound = {
            width: 40,
            height: 20
        };
        const bg = new $iuB9z.Graphics().clear().roundRect(-bgBound.width / 2, -bgBound.height / 2, bgBound.width, bgBound.height).fill(color);
        this.addChild(bg);
        return bg;
    }
    handleSwitcher(isActive) {
        this.isActive = isActive;
        this.handleSwitch(this.isActive);
        new (0, $8xLbP.default)(this);
    }
    handleSwitcherOff() {
        if (!this.isActive) return;
        this.handleSwitcher(false);
    }
    addInteractivity() {
        const handleDownFunc = ()=>this.handleSwitcher(!this.isActive);
        (0, $16Wgx.default)(this, {
            handleDownFunc: handleDownFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    setActive(v) {
        this.grayBg.alpha = this.isActive ? 1 - v : v;
        this.greenBg.alpha = this.isActive ? v : 1 - v;
        this.button.x = this.isActive ? 2 * $621ca3294779f8aa$var$BUTTON_X * v : 2 * $621ca3294779f8aa$var$BUTTON_X * (1 - v);
    }
    addButton(color) {
        this.button = new $iuB9z.Graphics().circle(-$621ca3294779f8aa$var$BUTTON_X, 0, 8).fill(color);
        this.addChild(this.button);
    }
}

});
parcelRegister("8xLbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $074e271eb87a9bab$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $074e271eb87a9bab$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(Switcher){
        super();
        const alpha = 0;
        new (0, $6m47o.default).Tween({
            alpha: alpha
        }).to({
            alpha: 1
        }, 500).easing((0, $6m47o.default).Easing.Linear.None).onUpdate(({ alpha: alpha })=>{
            Switcher.setActive(alpha);
        }).start();
    }
}

});



parcelRegister("jtirH", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c5a2df4ae2bc79$export$2e2bcd8739ae039);
function $34c5a2df4ae2bc79$export$2e2bcd8739ae039(cCoord, cCircumPoint, aSide1, aSide2) {
    let angle = Math.atan2(cCircumPoint.y - cCoord.y, cCircumPoint.x - cCoord.x);
    if (angle < 0) angle += 2 * Math.PI;
    let start = aSide1;
    let end = aSide2;
    if (start < 0) start += 2 * Math.PI;
    if (end < 0) end += 2 * Math.PI;
    if (start <= end) return angle >= start && angle <= end;
    else return angle >= start || angle <= end;
}

});

parcelRegister("jISXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $66faaaf67ef5cb50$export$2e2bcd8739ae039);
function $66faaaf67ef5cb50$export$2e2bcd8739ae039(dim, CENTER_OF_CIRCLE) {
    if (dim.WIDTH > dim.HEIGHT) return CENTER_OF_CIRCLE;
    return {
        x: dim.WIDTH / 2,
        y: dim.HEIGHT / 2
    };
}

});

parcelRegister("beJMG", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $24797d7b1c25d5bc$export$84c26df82650dc9b);

var $awcfo = parcelRequire("awcfo");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $24797d7b1c25d5bc$var$cachedGroups = {};
function $24797d7b1c25d5bc$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $24797d7b1c25d5bc$var$cachedGroups[uid] || $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $bLlTJ.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $awcfo.BindGroup)(bindGroupResources);
    $24797d7b1c25d5bc$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("6RGCN", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $cb3b5b020b2ab749$export$e56d0a06781accc9);

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");

var $2GH55 = parcelRequire("2GH55");
"use strict";
class $cb3b5b020b2ab749$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $NbSCN.nextPow2)(minWidth);
        minHeight = (0, $NbSCN.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.resetTransform();
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $cb3b5b020b2ab749$export$e56d0a06781accc9 = new $cb3b5b020b2ab749$export$62d9f0b8aada09d7();
(0, $2GH55.GlobalResourceRegistry).register($cb3b5b020b2ab749$export$e56d0a06781accc9);

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


var $75RpY = parcelRequire("75RpY");

var $75RpY = parcelRequire("75RpY");

var $erVR3 = parcelRequire("erVR3");

var $5ehzb = parcelRequire("5ehzb");

var $3ANoO = parcelRequire("3ANoO");

var $eymUv = parcelRequire("eymUv");
const $c00f1009c486728c$export$64436d1175f556d9 = {
    circum: "x",
    center: "2x"
};
const $c00f1009c486728c$export$ca8f2c484d507a5d = 200;
const $c00f1009c486728c$export$525b32b135428804 = 140;
const $c00f1009c486728c$export$3cf98fad6d5d4142 = 40;
const $c00f1009c486728c$export$2f65378ba556425d = 270;
const $c00f1009c486728c$export$fd1bf64c4a4ea04a = [
    (0, $eymUv.default)(40),
    (0, $eymUv.default)(140),
    (0, $eymUv.default)(270)
];
const $c00f1009c486728c$export$c7609d9da8d80867 = {
    x: 500,
    y: 360
};
const $c00f1009c486728c$export$df1c1fbcdd7e8a48 = {
    x: 300,
    y: 600
};
const $c00f1009c486728c$export$158208f930a33a87 = {
    x: 100,
    y: 20
};
const $c00f1009c486728c$export$186dbbe504e85fe1 = [
    {
        x: 90,
        y: 800
    },
    {
        x: 450,
        y: 800
    },
    {
        x: 810,
        y: 800
    }
];
const $c00f1009c486728c$export$75f2cc8245aafe09 = [
    {
        x: -340,
        y: 480
    },
    {
        x: 120,
        y: 480
    },
    {
        x: -340,
        y: 660
    }
];
const $c00f1009c486728c$export$840ec2322406bfdd = {
    x: 1130,
    y: 200
};
const $c00f1009c486728c$export$190b4c043fb6edf4 = {
    x: 1500,
    y: 800
};
const $c00f1009c486728c$export$bdea539c223eec51 = [
    0xFFBD06,
    0x000000,
    0x000000
];
const $c00f1009c486728c$export$2e51dc0dfab2d766 = "circle-theorem-1";
const $c00f1009c486728c$export$b6c787c9f0e7e936 = [
    {
        text: "2",
        x: 75,
        y: 0,
        color: 0x000000
    },
    {
        text: "x",
        x: 109,
        y: 0,
        color: 0x000000,
        fontSize: 40
    },
    {
        text: "x\xb0",
        x: 150,
        y: 0,
        color: (0, $3ANoO.CIRCUM_ANGLE_COLOR).textColor,
        fontWeight: "600"
    },
    {
        text: "=",
        x: 259,
        y: 0,
        color: 0x000000
    },
    {
        text: "2x\xb0",
        x: 300,
        y: 0,
        color: (0, $3ANoO.CENTER_ANGLE_COLOR).textColor,
        fontWeight: "600"
    }
];



var $iuB9z = parcelRequire("iuB9z");
var $e203f33a80027382$export$cb883390c27ec6dd = /*#__PURE__*/ function(EnumEventBus) {
    EnumEventBus["setCalcLine"] = "SET_CALC_LINE";
    EnumEventBus["showCalcLine"] = "SHOW_CALCULATION_LINE";
    EnumEventBus["setCircumPoint"] = "SET_CIRCUMFERENCE_POINT";
    EnumEventBus["setCentralAngle"] = "SET_CENTRAL_ANGLE";
    EnumEventBus["setRotateCircle"] = "SET_ROTATE_CIRCLE";
    EnumEventBus["segmentMode"] = "SEGMENT_MODE";
    return EnumEventBus;
}({});
const $e203f33a80027382$export$f6644f0f2c90144b = new (0, $iuB9z.EventEmitter)();


class $def0a43c0781f862$export$2e2bcd8739ae039 extends (0, $5ehzb.default) {
    static instance;
    constructor(cCoord){
        super(cCoord, (0, $c00f1009c486728c$export$ca8f2c484d507a5d), (0, $c00f1009c486728c$export$fd1bf64c4a4ea04a));
        (0, $e203f33a80027382$export$f6644f0f2c90144b).on((0, $e203f33a80027382$export$cb883390c27ec6dd).setRotateCircle, (v)=>this.moveAllPoints(v));
        (0, $e203f33a80027382$export$f6644f0f2c90144b).on((0, $e203f33a80027382$export$cb883390c27ec6dd).setCentralAngle, (v)=>this.moveCentralAngle(v));
        (0, $e203f33a80027382$export$f6644f0f2c90144b).on((0, $e203f33a80027382$export$cb883390c27ec6dd).setCircumPoint, (v)=>this.moveCircumPoint(v));
    }
    moveAllPoints(v) {
        const points = this.getRedPoints();
        const pointInfoArr = this.getRefRadians().map((ref, refI)=>({
                pTag: points[refI].tag,
                radian: ref + v / 100 * (Math.PI / 3)
            }));
        this.setRadian(pointInfoArr, true);
    }
    moveCentralAngle(v) {
        const refPoints = this.getRefRadians();
        const points = this.getRedPoints();
        const pointInfoArr = [
            points[0],
            points[1]
        ].map((p, pI)=>{
            const radian = refPoints[pI] + (pI == 0 ? 1 : -1) * v / 100 * (Math.PI / 8);
            return {
                pTag: p.tag,
                radian: radian
            };
        });
        this.setRadian(pointInfoArr, true);
    }
    moveCircumPoint(v) {
        const circumPoint = this.getRedPoints()[2];
        const cirumRefRadian = this.getRefRadians()[2];
        this.setRadian([
            {
                pTag: circumPoint.tag,
                radian: cirumRefRadian + v / 100 * Math.PI / 6
            }
        ], true);
    }
}



var $erVR3 = parcelRequire("erVR3");

var $d0yDD = parcelRequire("d0yDD");
class $48d82246004e3057$export$2e2bcd8739ae039 {
    rLine1CirSide1 = new (0, $d0yDD.default)();
    rLine2CenSide2 = new (0, $d0yDD.default)();
    lLine1CirSide2 = new (0, $d0yDD.default)();
    lLine2CenSide1 = new (0, $d0yDD.default)();
    // r1 - circum - l1
    // r1 - side1 - l2
    // r2 - side2 - l1
    // r2 - center - l2
    constructor(){
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.clearAll());
    }
    clearAll() {
        [
            this.rLine1CirSide1,
            this.rLine2CenSide2,
            this.lLine1CirSide2,
            this.lLine2CenSide1
        ].forEach((l)=>l.clear());
    }
    draw([center, side1, side2, circum]) {
        this.rLine1CirSide1.draw(circum, side1);
        this.rLine2CenSide2.draw(center, side2);
        this.lLine1CirSide2.draw(circum, side2);
        this.lLine2CenSide1.draw(center, side1);
    }
}



var $erVR3 = parcelRequire("erVR3");


var $g4gW0 = parcelRequire("g4gW0");

var $3ANoO = parcelRequire("3ANoO");

var $eP48i = parcelRequire("eP48i");

var $a92Ax = parcelRequire("a92Ax");

var $cwj7p = parcelRequire("cwj7p");
class $7b4cfedf1141f893$export$2e2bcd8739ae039 {
    centerAngle = new (0, $g4gW0.default)("center", (0, $3ANoO.CENTER_ANGLE_COLOR));
    circumAngle = new (0, $g4gW0.default)("circum", (0, $3ANoO.CIRCUM_ANGLE_COLOR));
    cloneCircumAngles = [
        new (0, $g4gW0.default)("circum2", (0, $3ANoO.CIRCUM_ANGLE_COLOR)),
        new (0, $g4gW0.default)("circum3", (0, $3ANoO.CIRCUM_ANGLE_COLOR))
    ];
    constructor(){
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    setAllVisible(status) {
        this.centerAngle.setVisible(status);
        this.circumAngle.setVisible(status);
    }
    emitAngles = (degree)=>(0, $e203f33a80027382$export$f6644f0f2c90144b).emit((0, $e203f33a80027382$export$cb883390c27ec6dd).setCalcLine, degree);
    drawCenterAngle(cPoint, s1Point, s2Point, clockwise) {
        const { startRadian: startRadian, endRadian: endRadian } = (0, $a92Ax.default)(cPoint, s1Point, s2Point);
        const degree = (0, $cwj7p.default)({
            startRadian: startRadian,
            endRadian: endRadian
        }, clockwise);
        this.centerAngle.draw(cPoint, startRadian, endRadian, degree, clockwise);
        this.centerAngle.x = cPoint.x;
        this.centerAngle.y = cPoint.y;
        return degree;
    }
    drawCircumAngle(circumPoint, s1Point, s2Point, degree, clockwise) {
        const angles = (0, $a92Ax.default)(circumPoint, s1Point, s2Point);
        const smallDistance = Math.min((0, $eP48i.default)(circumPoint, s1Point), (0, $eP48i.default)(circumPoint, s2Point));
        this.circumAngle.smallDistance = smallDistance;
        this.circumAngle.draw(circumPoint, angles.startRadian, angles.endRadian, degree / 2, clockwise);
        this.circumAngle.x = circumPoint.x;
        this.circumAngle.y = circumPoint.y;
    }
    draw([cPoint, s1Point, s2Point, circumPoint], clockwise) {
        const centerDegree = this.drawCenterAngle(cPoint, s1Point, s2Point, clockwise);
        this.drawCircumAngle(circumPoint, s1Point, s2Point, centerDegree, clockwise);
        this.emitAngles(centerDegree);
    }
}



var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $hCdov = parcelRequire("hCdov");

class $75b4cc9e06448515$export$2e2bcd8739ae039 extends $iuB9z.Graphics {
    Layers = (0, $9ec1t.default).getInstance();
    startRadian;
    endRadian;
    initialRadian;
    cCoord;
    startPoint;
    fillColor;
    constructor(cCoord, startPoint, radian, color){
        super();
        this.cCoord = cCoord;
        this.initialRadian = radian;
        this.startPoint = startPoint;
        this.startRadian = radian;
        this.endRadian = radian;
        this.fillColor = color;
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Bottom.addChild(this);
    draw(startRadian, endRadian, startPoint) {
        this.startRadian = startRadian;
        this.endRadian = endRadian;
        startPoint && (this.startPoint = startPoint);
        this.drawBg();
    }
    drawBg() {
        const [s1Point, s2Point] = (0, $hCdov.default)(this.cCoord, [
            this.startRadian,
            this.endRadian
        ], (0, $c00f1009c486728c$export$ca8f2c484d507a5d));
        this.clear().moveTo(this.startPoint.x, this.startPoint.y).lineTo(s1Point.x, s1Point.y).arc(this.cCoord.x, this.cCoord.y, (0, $c00f1009c486728c$export$ca8f2c484d507a5d), this.startRadian, this.endRadian, true).lineTo(s2Point.x, s2Point.y).fill({
            color: this.fillColor,
            alpha: .7
        });
    }
}




var $erVR3 = parcelRequire("erVR3");
class $6f3ab927158d59a0$export$2e2bcd8739ae039 {
    PointManager = (0, $def0a43c0781f862$export$2e2bcd8739ae039).getInstance();
    cCoord;
    centerBg;
    circumBg;
    constructor(cCoord, radian){
        this.cCoord = cCoord;
        const circlePoint = this.PointManager.circlePoint;
        const circumPoint = this.PointManager.getRedPoints()[2];
        this.circumBg = new (0, $75b4cc9e06448515$export$2e2bcd8739ae039)(this.cCoord, circumPoint, radian, 0x98d6ff);
        this.centerBg = new (0, $75b4cc9e06448515$export$2e2bcd8739ae039)(this.cCoord, circlePoint, radian, 0xffceeb);
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).cancelledCircleAnim, ()=>this.handleCancelCircleAnim());
    }
    handleCancelCircleAnim = ()=>setTimeout(()=>[
                this.circumBg,
                this.centerBg
            ].forEach((bg)=>bg.clear()), 0);
}



var $lO7zi = parcelRequire("lO7zi");

var $eymUv = parcelRequire("eymUv");

var $a92Ax = parcelRequire("a92Ax");

var $cwj7p = parcelRequire("cwj7p");

var $erVR3 = parcelRequire("erVR3");
class $d4e50fd1d1e9fcc7$export$2e2bcd8739ae039 {
    center = new (0, $lO7zi.default)("O");
    side1 = new (0, $lO7zi.default)("A");
    side2 = new (0, $lO7zi.default)("B");
    circum = new (0, $lO7zi.default)("C");
    constructor(){
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    setVisible = (visible)=>[
            this.center,
            this.side1,
            this.side2,
            this.circum
        ].forEach((pName)=>pName.visible = visible);
    updateCenterName([cPoint, s1Point, s2Point], cClockwise) {
        const cAngles = (0, $a92Ax.default)(cPoint, s1Point, s2Point);
        const degree = (0, $cwj7p.default)(cAngles, cClockwise);
        const initialAngle = cClockwise ? cAngles.endRadian : cAngles.startRadian;
        const nameAngle = initialAngle + (0, $eymUv.default)(degree / 2) + Math.PI;
        const coord = {
            x: Math.cos(nameAngle) * 30 + cPoint.x,
            y: Math.sin(nameAngle) * 30 + cPoint.y
        };
        this.center.updateCoord(coord);
    }
    updateCoord(coords) {
        this.side1.updateCoord(coords[0]);
        this.side2.updateCoord(coords[1]);
        this.circum.updateCoord(coords[2]);
    }
}



var $iiVV4 = parcelRequire("iiVV4");

var $b2sIL = parcelRequire("b2sIL");


const $226f0246341a91cf$var$SliderGen = [
    {
        head: "circumference angle",
        colors: {
            bgColor: 0x21D4FE,
            barColor: 0x000000,
            buttonColor: 0x21D4FE
        },
        onUpdate: (v)=>(0, $e203f33a80027382$export$f6644f0f2c90144b).emit((0, $e203f33a80027382$export$cb883390c27ec6dd).setCircumPoint, v - 100)
    },
    {
        head: "central angle",
        colors: {
            bgColor: 0xFC99C4,
            barColor: 0x000000,
            buttonColor: 0xFC99C4
        },
        onUpdate: (v)=>(0, $e203f33a80027382$export$f6644f0f2c90144b).emit((0, $e203f33a80027382$export$cb883390c27ec6dd).setCentralAngle, v - 100)
    },
    {
        head: "rotate the circle",
        colors: {
            bgColor: 0xBFBFBF,
            barColor: 0x000000,
            buttonColor: 0x000000
        },
        onUpdate: (v)=>(0, $e203f33a80027382$export$f6644f0f2c90144b).emit((0, $e203f33a80027382$export$cb883390c27ec6dd).setRotateCircle, v - 100)
    }
];
class $226f0246341a91cf$export$2e2bcd8739ae039 extends (0, $b2sIL.default) {
    constructor(){
        super($226f0246341a91cf$var$SliderGen, (0, $c00f1009c486728c$export$186dbbe504e85fe1), (0, $c00f1009c486728c$export$75f2cc8245aafe09));
    }
}



var $erVR3 = parcelRequire("erVR3");


var $iD90R = parcelRequire("iD90R");

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $815dc5ed23d1d47a$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    Anim = (0, $1PAc2.default).getInstance();
    isStopped = false;
    AngleBg;
    cCoord;
    constructor(AngleBg, radian, cCoord, onComp, resolve){
        super();
        this.AngleBg = AngleBg;
        this.cCoord = cCoord;
        this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, ()=>this.isStopped = true);
        if (this.getIsCancelled()) {
            resolve();
            return;
        }
        new (0, $6m47o.default).Tween({
            ...AngleBg
        }).to({
            startRadian: radian
        }, 2000).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((ABg)=>{
            if (this.isStopped) {
                AngleBg.clear();
                resolve();
                return;
            }
            this.AngleBg.draw(ABg.startRadian, ABg.endRadian);
        }).onComplete(()=>onComp()).start();
    }
}



var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $d89e0e7e59c52bce$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    Anim = (0, $1PAc2.default).getInstance();
    isStopped = false;
    constructor(Element, onComp, resolve){
        super();
        this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, ()=>this.isStopped = true);
        if (this.Anim.getIsCancelled()) {
            onComp();
            return;
        }
        const o = {
            a: 1
        };
        new (0, $6m47o.default).Tween({
            ...o
        }).to({
            a: 0
        }, 1500).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((o)=>{
            if (this.isStopped) {
                Element.alpha = 0;
                this.isStopped = true;
                resolve();
                return;
            }
            Element.alpha = o.a;
        }).onComplete(()=>onComp()).start();
    }
}


function $98d14260507aa9f4$export$d1e2ccf942bf99d6(angleBg) {
    return new Promise((resolve)=>new (0, $d89e0e7e59c52bce$export$2e2bcd8739ae039)(angleBg, resolve, resolve));
}
function $98d14260507aa9f4$export$e0576084f6bcee09(AngleBg, radian, coord) {
    AngleBg.clear();
    AngleBg.alpha = 1;
    AngleBg.startRadian = AngleBg.initialRadian;
    AngleBg.endRadian = AngleBg.initialRadian;
    return new Promise((resolve)=>new (0, $815dc5ed23d1d47a$export$2e2bcd8739ae039)(AngleBg, radian, coord, resolve, resolve));
}



var $hCdov = parcelRequire("hCdov");

var $darcK = parcelRequire("darcK");

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $076e07b4bb800e34$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    Anim = (0, $1PAc2.default).getInstance();
    isStopped = false;
    constructor(targetRadians, duration, onUpdate, onComp, resolve){
        super();
        this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, ()=>this.isStopped = true);
        const radians = {
            radian1: 0,
            radian2: 0,
            radian3: 0
        };
        if (this.getIsCancelled()) {
            resolve();
            return;
        }
        new (0, $6m47o.default).Tween({
            ...radians
        }).to({
            radian1: targetRadians[0],
            radian2: targetRadians[1],
            radian3: targetRadians[2]
        }, duration).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((r)=>{
            if (this.isStopped) {
                this.isStopped = true;
                resolve();
                return;
            }
            onUpdate([
                r.radian1,
                r.radian2,
                r.radian3
            ]);
        }).onComplete(()=>onComp()).start();
    }
}



const $1e3c3ad5052b3e7c$var$bRadian = Math.PI / 10;
const $1e3c3ad5052b3e7c$var$radiansListArr = [
    [
        [
            -Math.PI / 20 * 1.6,
            -Math.PI / 20 * 1.2,
            -Math.PI / 6
        ],
        [
            Math.PI / 6 * 1.5,
            Math.PI / 6 * 2,
            Math.PI / 1.8
        ],
        [
            Math.PI / 20,
            -Math.PI / 15,
            -Math.PI / 1.7
        ]
    ],
    [
        [
            -Math.PI / 9,
            Math.PI / 9,
            -Math.PI / 6
        ],
        [
            Math.PI / 2.25,
            Math.PI / 4,
            Math.PI / 2
        ],
        [
            Math.PI / 6,
            -Math.PI / 6,
            -Math.PI / 2
        ]
    ]
];
async function $1e3c3ad5052b3e7c$export$881542f60896fc9(AngleBgArr, circle, PointManager, AngleManager, LineManager) {
    const radiansList = $1e3c3ad5052b3e7c$var$radiansListArr[AngleBgArr.length - 1];
    const refAngles = PointManager.getInitialRadians();
    const handleUpdate = (radians, offsetAngles)=>{
        $1e3c3ad5052b3e7c$var$danceElements(AngleBgArr, circle, PointManager, AngleManager, LineManager, refAngles.map((rAngle, rI)=>rAngle + offsetAngles[rI]), radians);
    };
    const calcPrevArray = (index)=>{
        return radiansList.reduce((total, curr, currIndex)=>{
            const t = [
                total[0] + curr[0],
                total[1] + curr[1],
                total[2] + curr[2]
            ];
            return index > currIndex ? t : total;
        }, [
            0,
            0,
            0
        ]);
    };
    const calcDuration = (index)=>Math.floor(Math.abs(radiansList[index][2] / $1e3c3ad5052b3e7c$var$bRadian) * 200);
    const lastPosition = calcPrevArray(radiansList.length).map((r)=>-r);
    const lastDuration = Math.floor(Math.abs(lastPosition[2] / $1e3c3ad5052b3e7c$var$bRadian) * 400);
    await $1e3c3ad5052b3e7c$var$movePoints(radiansList[0], calcDuration(0), (r)=>handleUpdate(r, [
            0,
            0,
            0
        ]));
    await $1e3c3ad5052b3e7c$var$movePoints(radiansList[1], calcDuration(1), (r)=>handleUpdate(r, calcPrevArray(1)));
    await $1e3c3ad5052b3e7c$var$movePoints(radiansList[2], calcDuration(2), (r)=>handleUpdate(r, calcPrevArray(2)));
    await $1e3c3ad5052b3e7c$var$movePoints(lastPosition, lastDuration, (r)=>handleUpdate(r, calcPrevArray(radiansList.length)));
}
const $1e3c3ad5052b3e7c$var$movePoints = (tRadians, duration, handleUpdate)=>{
    return new Promise((resolve)=>{
        new (0, $076e07b4bb800e34$export$2e2bcd8739ae039)(tRadians, duration, (r)=>handleUpdate(r, 0), resolve, resolve);
    });
};
function $1e3c3ad5052b3e7c$var$danceElements(AngleBgArr, circle, PointManager, AngleManager, LineManager, refAngles, offsetAngles) {
    const getRadian = (index)=>(0, $darcK.normalizeRadian)(refAngles[index] + offsetAngles[index]);
    const PointRadians = PointManager.getRedPoints().map((rP, rPI)=>getRadian(rPI));
    const centerPoint = PointManager.getPoints()[0];
    const points = (0, $hCdov.default)(centerPoint, PointRadians, (0, $c00f1009c486728c$export$ca8f2c484d507a5d));
    const startPointArr = [
        points[2],
        centerPoint
    ];
    LineManager.rLine1CirSide1.draw(points[0], points[2]);
    LineManager.lLine1CirSide2.draw(points[1], points[2]);
    if (AngleBgArr.length > 1) {
        LineManager.lLine2CenSide1.draw(centerPoint, points[0]);
        LineManager.rLine2CenSide2.draw(centerPoint, points[1]);
    }
    AngleManager.draw([
        centerPoint,
        ...points
    ], false);
    AngleManager.circumAngle.AngleValue.setValue("x");
    AngleManager.centerAngle.AngleValue.setValue("2x");
    AngleBgArr.forEach((AngleBg, aI)=>AngleBg.draw(PointRadians[1], PointRadians[0], startPointArr[aI]));
    circle.draw({
        radians: PointRadians.sort((a, b)=>a - b),
        radius: circle.radius
    });
}




var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $423a323078bbef72$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    Anim = (0, $1PAc2.default).getInstance();
    isStopped = false;
    constructor(Angle, endCoord, startRadian, endRadian, onUpdate, onComp, resolve){
        super();
        this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, ()=>this.isStopped = true);
        const values = {
            x: Angle.x,
            y: Angle.y,
            startRadian: Angle.startRadian,
            endRadian: Angle.endRadian
        };
        if (this.Anim.getIsCancelled()) {
            Angle.setVisible(false);
            resolve();
            return;
        }
        new (0, $6m47o.default).Tween({
            ...values
        }).to({
            x: endCoord.x,
            y: endCoord.y,
            startRadian: startRadian,
            endRadian: endRadian
        }, 2000).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((v)=>{
            if (this.isStopped) {
                resolve();
                return;
            }
            onUpdate(Angle, {
                coord: {
                    x: v.x,
                    y: v.y
                },
                startRadian: v.startRadian,
                endRadian: v.endRadian
            });
        }).onComplete(()=>onComp()).start();
    }
}




var $a92Ax = parcelRequire("a92Ax");

var $iD90R = parcelRequire("iD90R");
async function $c356b67ec1aa4196$export$d8a8509877285b7d(circle, PointManager, AngleManager) {
    const radians = PointManager.getInitialRadians();
    const points = PointManager.getRedPoints();
    const angles = (0, $a92Ax.default)(points[2], points[0], points[1]);
    AngleManager.cloneCircumAngles.forEach((angle)=>{
        angle.alpha = 1;
        angle.AngleValue.alpha = 1;
        $c356b67ec1aa4196$var$drawCloneAngle(angle, {
            coord: points[2],
            startRadian: angles.startRadian,
            endRadian: angles.endRadian
        });
    });
    await $c356b67ec1aa4196$var$drawMoveAngle(AngleManager.cloneCircumAngles[0], {
        x: circle.x,
        y: circle.y
    }, radians[0], Math.PI / 2);
    await $c356b67ec1aa4196$var$drawMoveAngle(AngleManager.cloneCircumAngles[1], {
        x: circle.x,
        y: circle.y
    }, Math.PI / 2, radians[1]);
    AngleManager.cloneCircumAngles.forEach((cAngle)=>{
        $c356b67ec1aa4196$var$drawReduceOpacityAnim(cAngle);
        $c356b67ec1aa4196$var$drawReduceOpacityAnim(cAngle.AngleValue);
    });
    await (0, $iD90R.addCustomDelay)(1000);
}
async function $c356b67ec1aa4196$var$drawMoveAngle(Angle, coord, sRadian, endRadian) {
    return new Promise((resolve)=>{
        new (0, $423a323078bbef72$export$2e2bcd8739ae039)(Angle, coord, sRadian, endRadian, $c356b67ec1aa4196$var$drawCloneAngle, resolve, resolve);
    });
}
async function $c356b67ec1aa4196$var$drawReduceOpacityAnim(Angle) {
    return new Promise((resolve)=>{
        new (0, $d89e0e7e59c52bce$export$2e2bcd8739ae039)(Angle, resolve, resolve);
    });
}
function $c356b67ec1aa4196$var$drawCloneAngle(angle, Detail) {
    const { coord: coord, startRadian: startRadian, endRadian: endRadian } = Detail;
    angle.draw(coord, startRadian, endRadian, 50, false);
    angle.AngleValue.setValue("x");
    angle.x = coord.x;
    angle.y = coord.y;
}


async function $161f73aee6c606f5$export$2721aded6352b5ea(context, cb) {
    const { circle: circle, LineManager: LineManager, PointManager: PointManager, AngleManager: AngleManager, AngleBgManager: AngleBgManager } = context;
    const [cCoord, cSide1Point, cSide2Point, cCircumPoint] = PointManager.getPoints().map((p)=>({
            x: p.x,
            y: p.y
        }));
    const centerPoint = PointManager.getPoints()[0];
    // Circle
    centerPoint.draw(cCoord);
    circle.setRadians(Array(3).fill((0, $c00f1009c486728c$export$fd1bf64c4a4ea04a)[2]));
    await (0, $iD90R.drawPointsAnim)([
        centerPoint
    ]);
    await (0, $iD90R.drawCircleAnim)(circle, (0, $c00f1009c486728c$export$fd1bf64c4a4ea04a)[2] - 2 * Math.PI, 2, true, cCoord);
    (0, $iD90R.drawLineAnim)(LineManager.lLine1CirSide2, cCircumPoint, cSide2Point);
    await (0, $iD90R.drawLineAnim)(LineManager.rLine1CirSide1, cCircumPoint, cSide1Point);
    await (0, $iD90R.drawAngleAnim)(AngleManager.circumAngle, (0, $c00f1009c486728c$export$64436d1175f556d9).circum);
    circle.setRadians([
        (0, $c00f1009c486728c$export$fd1bf64c4a4ea04a)[0],
        (0, $c00f1009c486728c$export$fd1bf64c4a4ea04a)[0],
        (0, $c00f1009c486728c$export$fd1bf64c4a4ea04a)[2]
    ]);
    const finalRadian = (0, $c00f1009c486728c$export$fd1bf64c4a4ea04a)[1];
    await (0, $iD90R.drawCircleAnim)(circle, finalRadian, 1, false, cCoord);
    await (0, $98d14260507aa9f4$export$e0576084f6bcee09)(AngleBgManager.circumBg, finalRadian, cCoord);
    circle.setRadians((0, $c00f1009c486728c$export$fd1bf64c4a4ea04a));
    await (0, $1e3c3ad5052b3e7c$export$881542f60896fc9)([
        AngleBgManager.circumBg
    ], circle, PointManager, AngleManager, LineManager);
    (0, $iD90R.drawLineAnim)(LineManager.lLine2CenSide1, cCoord, cSide2Point);
    await (0, $iD90R.drawLineAnim)(LineManager.rLine2CenSide2, cCoord, cSide1Point);
    await (0, $c356b67ec1aa4196$export$d8a8509877285b7d)(circle, PointManager, AngleManager);
    await (0, $iD90R.drawAngleAnim)(AngleManager.centerAngle, (0, $c00f1009c486728c$export$64436d1175f556d9).center);
    await (0, $98d14260507aa9f4$export$e0576084f6bcee09)(AngleBgManager.centerBg, finalRadian, cCoord);
    await (0, $1e3c3ad5052b3e7c$export$881542f60896fc9)([
        AngleBgManager.circumBg,
        AngleBgManager.centerBg
    ], circle, PointManager, AngleManager, LineManager);
    (0, $98d14260507aa9f4$export$d1e2ccf942bf99d6)(AngleBgManager.centerBg);
    await (0, $98d14260507aa9f4$export$d1e2ccf942bf99d6)(AngleBgManager.circumBg);
    cb();
}



var $e8wW1 = parcelRequire("e8wW1");

var $darcK = parcelRequire("darcK");

function $658023195ce0a6bf$export$fa3e660ea31c7d1b(PointManager, offsetAngle) {
    const refAngles = PointManager.getInitialRadians();
    const getRadian = (index)=>(0, $darcK.normalizeRadian)(refAngles[index] + offsetAngle);
    const redPointRadians = PointManager.getRedPoints().map((rP, rPI)=>({
            pTag: rP.tag,
            radian: getRadian(rPI)
        }));
    PointManager.setRadian(redPointRadians);
}
function $658023195ce0a6bf$export$34ce145ca2b805f0(radian, circle, PointManager, LineManager, AngleManager) {
    const points = PointManager.getPoints();
    const radians = PointManager.getRadians();
    $658023195ce0a6bf$export$fa3e660ea31c7d1b(PointManager, radian);
    circle.draw({
        radians: radians,
        radius: circle.radius
    });
    LineManager.draw(points);
    AngleManager.draw(points, true);
    AngleManager.centerAngle.AngleValue.setValue((0, $c00f1009c486728c$export$64436d1175f556d9).center);
    AngleManager.circumAngle.AngleValue.setValue((0, $c00f1009c486728c$export$64436d1175f556d9).circum);
}



class $2ae0d06b7c1d19f8$export$2e2bcd8739ae039 {
    PointManager;
    AngleManager;
    AngleBgManager;
    LineManager;
    circle;
    isSwitcherActive;
    constructor(PointManager, AngleManager, AngleBgManager, LineManager, circle){
        this.PointManager = PointManager;
        this.AngleManager = AngleManager;
        this.AngleBgManager = AngleBgManager;
        this.LineManager = LineManager;
        this.circle = circle;
        this.isSwitcherActive = false;
        this.getDelayForStartAnim = ()=>this.isSwitcherActive ? 150 : 0;
        this.addCircAnimBut = ()=>new (0, $e8wW1.default)((0, $c00f1009c486728c$export$840ec2322406bfdd), ()=>this.runAnimations(), ()=>this.getDelayForStartAnim());
        (0, $658023195ce0a6bf$export$fa3e660ea31c7d1b)(this.PointManager, 0);
        this.AngleManager.draw(PointManager.getPoints(), false);
        this.addCircAnimBut();
        (0, $e203f33a80027382$export$f6644f0f2c90144b).on((0, $e203f33a80027382$export$cb883390c27ec6dd).segmentMode, (v)=>this.isSwitcherActive = v);
    }
    getDelayForStartAnim;
    addCircAnimBut;
    runAnimations() {
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).startedCircleAnim);
        const context = {
            circle: this.circle,
            LineManager: this.LineManager,
            PointManager: this.PointManager,
            AngleManager: this.AngleManager,
            AngleBgManager: this.AngleBgManager
        };
        const completedCircleAnim = ()=>{
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).getCircleCoord, {
                x: this.circle.x,
                y: this.circle.y
            });
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).completedCircleAnim);
        };
        (0, $161f73aee6c606f5$export$2721aded6352b5ea)(context, ()=>completedCircleAnim());
    }
}



var $fGH3X = parcelRequire("fGH3X");

var $iuB9z = parcelRequire("iuB9z");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");


var $erVR3 = parcelRequire("erVR3");

class $9132aab9f3bb2a7e$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    constructor(){
        super();
        this.addText();
        this.addCoord();
        this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.visible = false);
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.visible = true);
        (0, $e203f33a80027382$export$f6644f0f2c90144b).on((0, $e203f33a80027382$export$cb883390c27ec6dd).setCalcLine, (degree)=>this.updateDegrees([
                Number(degree),
                Number(degree) / 2
            ]));
    }
    addToLayer = ()=>this.Layers.Info.addChild(this);
    addText = ()=>(0, $c00f1009c486728c$export$b6c787c9f0e7e936).forEach((text)=>this.generateText(text));
    generateText(text) {
        const T = new $iuB9z.Text();
        T.text = text.text;
        T.x = text.x;
        T.y = text.y;
        T.style.fill = text.color;
        T.style.fontSize = text.fontSize ? text.fontSize : 50;
        T.style.fontWeight = text.fontWeight ? text.fontWeight : "500";
        this.addChild(T);
    }
    updateDegrees(degrees) {
        this.children[2].text = `${degrees[1]}\xb0`;
        this.children[4].text = `${degrees[0]}\xb0`;
    }
    addCoord() {
        const dim = this.Game.getDim();
        const Coord = dim.WIDTH > dim.HEIGHT ? (0, $c00f1009c486728c$export$df1c1fbcdd7e8a48) : {
            x: dim.WIDTH / 2 - 200,
            y: dim.HEIGHT / 2 + 250
        };
        Object.assign(this, Coord);
    }
}



var $3DpJv = parcelRequire("3DpJv");


var $9tAmQ = parcelRequire("9tAmQ");

var $gix9M = parcelRequire("gix9M");

class $ed9d454c3925edb9$export$2e2bcd8739ae039 extends (0, $gix9M.default) {
    constructor(){
        super({
            header: "Segment Mode",
            coords: {
                vertical: {
                    x: 240,
                    y: 660
                },
                horizontal: {
                    x: 160,
                    y: 240
                }
            },
            handleFunc: (v)=>(0, $e203f33a80027382$export$f6644f0f2c90144b).emit((0, $e203f33a80027382$export$cb883390c27ec6dd).segmentMode, v)
        });
    }
}


class $e6bd744aaf38ab91$export$2e2bcd8739ae039 extends (0, $9tAmQ.default) {
    constructor(cCoord){
        super(cCoord);
        (0, $e203f33a80027382$export$f6644f0f2c90144b).on((0, $e203f33a80027382$export$cb883390c27ec6dd).segmentMode, (v)=>this.handleSegmentVisible(v));
        new (0, $ed9d454c3925edb9$export$2e2bcd8739ae039)();
    }
}




var $jtirH = parcelRequire("jtirH");

var $hCdov = parcelRequire("hCdov");
function $be71474fb2e8e54a$export$8bcf5a95f698e8c4(radians, isbtw) {
    const r = [
        ...radians
    ];
    return isbtw ? [
        r[1],
        r[0],
        r[2]
    ] : r;
}



var $jISXQ = parcelRequire("jISXQ");
class $3ad20f2ee5255afa$export$2e2bcd8739ae039 {
    static instance;
    Game = (0, $75RpY.default).getInstance();
    cRadius = (0, $c00f1009c486728c$export$ca8f2c484d507a5d);
    cCoord = (0, $jISXQ.default)(this.Game.getDim(), (0, $c00f1009c486728c$export$c7609d9da8d80867));
    PointManager = new (0, $def0a43c0781f862$export$2e2bcd8739ae039)(this.cCoord);
    AngleBgManager = new (0, $6f3ab927158d59a0$export$2e2bcd8739ae039)(this.cCoord, this.PointManager.getRadians()[0]);
    LineManager = new (0, $48d82246004e3057$export$2e2bcd8739ae039)();
    AngleManager = new (0, $7b4cfedf1141f893$export$2e2bcd8739ae039)();
    PointTagManager = new (0, $d4e50fd1d1e9fcc7$export$2e2bcd8739ae039)();
    SliderManager = new (0, $226f0246341a91cf$export$2e2bcd8739ae039)();
    infoSlider = new (0, $fGH3X.default)((0, $c00f1009c486728c$export$840ec2322406bfdd));
    calcLine = new (0, $9132aab9f3bb2a7e$export$2e2bcd8739ae039)();
    CircleAnimationManager;
    SegmentChord = new (0, $e6bd744aaf38ab91$export$2e2bcd8739ae039)(this.cCoord);
    GuideText = new (0, $3DpJv.default)({
        x: 100,
        y: 10
    });
    circle;
    constructor(){
        if (!$3ad20f2ee5255afa$export$2e2bcd8739ae039.instance) $3ad20f2ee5255afa$export$2e2bcd8739ae039.instance = this;
        const radians = this.PointManager.getRadians();
        this.circle = new (0, $iiVV4.default)(this.cCoord, radians, (0, $c00f1009c486728c$export$bdea539c223eec51));
        this.CircleAnimationManager = new (0, $2ae0d06b7c1d19f8$export$2e2bcd8739ae039)(this.PointManager, this.AngleManager, this.AngleBgManager, this.LineManager, this.circle);
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.drawElements());
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).drawElements, ()=>this.drawElements());
        this.drawElements();
    }
    static getInstance = ()=>$3ad20f2ee5255afa$export$2e2bcd8739ae039.instance;
    generatePointTagPoints = ()=>(0, $hCdov.default)(this.cCoord, this.PointManager.getRadians(), this.cRadius + 34);
    drawElements() {
        const points = this.PointManager.getPoints();
        const radians = this.PointManager.getRadians();
        const isbtw = (0, $jtirH.default)(this.cCoord, points[3], radians[0], radians[1]);
        this.PointManager.draw();
        this.circle.draw({
            radians: (0, $be71474fb2e8e54a$export$8bcf5a95f698e8c4)(radians, isbtw),
            radius: this.cRadius
        });
        this.LineManager.draw(points);
        this.AngleManager.draw(points, isbtw);
        this.SegmentChord.draw((0, $c00f1009c486728c$export$ca8f2c484d507a5d), [
            radians[0],
            radians[1]
        ], [
            points[1],
            points[2]
        ], isbtw);
        this.PointTagManager.updateCenterName(points, isbtw);
        this.PointTagManager.updateCoord(this.generatePointTagPoints());
    }
}



const $74947fd5a78ed852$var$canvas = document.querySelector("#canvas");
if ($74947fd5a78ed852$var$canvas) window.context = new (0, $75RpY.default)($74947fd5a78ed852$var$canvas, (0, $c00f1009c486728c$export$2e51dc0dfab2d766), ()=>new (0, $3ad20f2ee5255afa$export$2e2bcd8739ae039)());
else console.error("Canvas is not found");


//# sourceMappingURL=index.619c2b1f.js.map
